<template>
  <div class=''>

    <CreateLocationModal
        :location="selected_location"
        :name_loc="selected_location_name"
        v-on:close-create-location-modal-success="closeCreateLocationModal(true)"
        ref="create_location_modal"></CreateLocationModal>
    <div class='flex flex-col gap-10p'>
      <div class="input-group plan_item origin flex flex-col fw-b"  v-for="(point, index) in points" :key="index">
        <div class="relative" v-if="index == 0">
          <div class="outer relative">
            <input autocomplete="off" placeholder="Starting Address" type="text" class="w-full" :id="'point' + index"
                   v-model="point.point.address"
                   @input="searchAllPoints(index)"
                   @focus="showSavedLocations(index)"
                   @click="showSavedLocations(index)">
            <div class="input_actions flex items-center gap-2p">
              <div  class="flag pointer" @click="saveLocation(point, 'Origin')">
                <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 2C1 1.44772 1.44772 1 2 1H8C8.55228 1 9 1.44772 9 2V10.3698C9 11.2893 7.86348 11.7214 7.25259 11.0342L5.74741 9.34084C5.34962 8.89332 4.65038 8.89332 4.25259 9.34084L2.74741 11.0342C2.13652 11.7214 1 11.2893 1 10.3698V2Z" stroke="#1FBC2F" stroke-width="2"/>
                </svg>
              </div>
              <div class="delete no_visibility">
                <CloseIcon />
              </div>
            </div>
            <div class="combined-dropdown absolute p-2 bordered" v-if="points[0].showCombinedList">
              <div v-if="filteredSavedLocations(0).length > 0" class="saved-locations-section">
                <ul class="flex flex-col">
                  <li v-for="(location, locIndex) in filteredSavedLocations(0)" :key="'saved-' + locIndex" 
                      class="pointer py-2 saved-location-item" @click="selectLocation(location, 0)">
                    <div class="flex items-center gap-2">
                      <svg class="bookmark-icon" width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 2C1 1.44772 1.44772 1 2 1H8C8.55228 1 9 1.44772 9 2V10.3698C9 11.2893 7.86348 11.7214 7.25259 11.0342L5.74741 9.34084C5.34962 8.89332 4.65038 8.89332 4.25259 9.34084L2.74741 11.0342C2.13652 11.7214 1 11.2893 1 10.3698V2Z" fill="#1FBC2F"/>
                      </svg>
                      <span class='location-name'>{{location.name}}</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div v-if="point.points && point.points.length > 0" class="address-search-section">
                <!-- <div v-if="filteredSavedLocations(0).length > 0" class="section-divider"></div> -->
                <ul class="flex flex-col">
                  <li v-for="(option, i) in point.points" :key="'search-' + i" class="pointer py-2 search-result-item">
                    <a href="javascript:void(0)" @click="updateDropOption(option, index)">
                      {{ option.address }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="dropdown_block" v-if="point.showList">
            <ul class="search-dropdown flex flex-col gap-5 py-5">
              <li v-for="(option, i) in point.points" :key="i">
                <a href="javascript:void(0)" @click="updateDropOption(option, index)">
                  {{ option.address }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="relative" v-else>
          <div class='revers_drops cursor-pointer '
               :class="{
                'has_pause': input_indexes_allow_pause.includes(index - 1)
              }"
               v-if='points && points.length && points.length > 1'
               @click='reverseTwoPoints(index)'
          >

            <ReverseArrows
            />
          </div>
          <div class="outer relative">
            <input autocomplete="off" placeholder="Address" type="text" class="w-full" :id="'point' + index"
                   v-model="point.point.address" @input="searchAllPoints(index)"
                   @focus="showSavedLocations(index)"
                   @click="showSavedLocations(index)"
            >
            <div class="input_actions flex items-center gap-2p">
              <div v-if='index < points.length -1' @click='togglePause(index)' class='pointer'>
                <ClockIcon />
              </div>
              <div class="flag pointer " @click="saveLocation(point, index + ' drop', index)">
                <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 2C1 1.44772 1.44772 1 2 1H8C8.55228 1 9 1.44772 9 2V10.3698C9 11.2893 7.86348 11.7214 7.25259 11.0342L5.74741 9.34084C5.34962 8.89332 4.65038 8.89332 4.25259 9.34084L2.74741 11.0342C2.13652 11.7214 1 11.2893 1 10.3698V2Z" stroke="#1FBC2F" stroke-width="2"/>
                </svg>
              </div>
              <div class="delete " @click="deletePoint(index)">
                <CloseIcon />
              </div>
            </div>
            <div class="combined-dropdown absolute p-2 bordered" v-if="points[index].showCombinedList">
              <div v-if="filteredSavedLocations(index).length > 0" class="saved-locations-section">
                <ul class="flex flex-col">
                  <li v-for="(location, locIndex) in filteredSavedLocations(index)" :key="'saved-' + locIndex" 
                      class="pointer py-2 saved-location-item" @click="selectLocation(location, index)">
                    <div class="flex items-center gap-2">
                      <svg class="bookmark-icon" width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 2C1 1.44772 1.44772 1 2 1H8C8.55228 1 9 1.44772 9 2V10.3698C9 11.2893 7.86348 11.7214 7.25259 11.0342L5.74741 9.34084C5.34962 8.89332 4.65038 8.89332 4.25259 9.34084L2.74741 11.0342C2.13652 11.7214 1 11.2893 1 10.3698V2Z" fill="#1FBC2F"/>
                      </svg>
                      <span class='location-name'>{{location.name}}</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div v-if="point.points && point.points.length > 0" class="address-search-section">
                <!-- <div v-if="filteredSavedLocations(index).length > 0" class="section-divider"></div> -->
                <ul class="flex flex-col">
                  <li v-for="(option, i) in point.points" :key="'search-' + i" class="pointer py-2 search-result-item">
                    <a href="javascript:void(0)" @click="updateDropOption(option, index)">
                      {{ option.address }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class='pause-input-wrapper' v-if='input_indexes_allow_pause.includes(index)'>
            <div class='pause-input relative flex gap-10p' >
              <input
                  type="number"
                  :value="getPauseValue(index)"
                  @input="updatePause(index, $event.target.value)"
                  placeholder="wait"
                  min='0'
                  class="no-spinners"
                  :ref='"pause_input_" + index'
                  :id='"pause_input_" + index'
              />
              <div class=" input_actions  delete "
                   @click='clearPause(index)'>
                <CloseIcon
                />
              </div>
            </div>
            <label class='minutes-label' :for='"pause_input_" + index'> minutes</label>
          </div>
          <div class="dropdown_block" v-if="point.showList">
            <ul class="search-dropdown flex flex-col gap-5 py-5">
              <li v-for="(option, i) in point.points" :key="i">
                <a href="javascript:void(0)" @click="updateDropOption(option, index)">
                  {{ option.address }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="actions flex justify-between items-center pt-8px">
      <div :disabled="points && points.length > 50" class="add-point flex gap-10p pointer align-items-center w-1/2"
           :class="{'disabled': points.length > 50}"
           @click="addPoint()">
        <div class="icon plus-icon">
          <svg width="10" height="10" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 1V16.9996" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round"/>
            <path d="M17.5 9L1.50038 9" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <span class='add-point-text'>
          Add destination
        </span>
      </div>
      <div class=" flex align-items-center gap-10p w-1/2 add-point-text pointer"
           @click="backToOrigin()">
        <div class="icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.5 4L23.5 10L17.5 10" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M23.5 10L18.86 5.64C17.7853 4.56471 16.4556 3.7792 14.9952 3.35677C13.5348 2.93434 11.9911 2.88875 10.5083 3.22426C9.02547 3.55976 7.6518 4.26543 6.51547 5.27542C5.37913 6.2854 4.51717 7.56678 4.01 9" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.9092 15.2066C20.2028 17.059 18.9046 18.6264 17.2161 19.6653C15.5275 20.7042 13.5432 21.1565 11.5713 20.952C9.59931 20.7474 7.75007 19.8975 6.31072 18.5341C4.87137 17.1708 3.92245 15.3704 3.61132 13.4124C3.30019 11.4544 3.64427 9.44852 4.59012 7.70616C5.53597 5.9638 7.03066 4.58251 8.84208 3.77678C10.6535 2.97106 12.6803 2.78598 14.6077 3.25031C15.3465 3.4283 16.0549 3.6979 16.7178 4.0496" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <span >
          Back to origin
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import L from "leaflet";
import {infoMessage} from "../../../../admin/src/services/messages";
import CreateLocationModal from "@/components/CreateLocationModal.vue";
import {rebuildPointsByIndex} from "@/services/helpers";
import {searchAddressesDebounced} from "@/services/addressSearch";
import {
  buildWaypointDisplayAddress,
  isFilledPlanPoint,
} from '@/services/planMapLocation';

import ReverseArrows from "@/assets/images/common/ReverseArrows.vue";
import ClockIcon from "@/assets/images/common/ClockIcon.vue";
import CloseIcon from "@/assets/images/common/CloseIcon.vue";

export default {
  name: 'PlanLocations',
  components: {CreateLocationModal, ReverseArrows, ClockIcon, CloseIcon},
  data() {
    return {
      locations_names: {
        start: null,
        end: null
      },
      input_indexes_allow_pause: [],
      points_pauses: [],
      cloned_points: null,
      selected_location: null,
      selected_location_name: null,
      points: [{
        label: '',
        point: {
          address: null,
          position: null
        },
        points: null,
        showList: false,
        showCombinedList: false,
        origin_locations_open: false,
        postcode: null,
        name: null,
        locationId: null,
        pendingCreate: false,
        mapWaypointRole: null,
      },
        {
          label: '',
          point: {
            address: null,
            position: null
          },
          points: null,
          showList: false,
          showCombinedList: false,
          origin_locations_open: false,
          postcode: null,
          name: null,
          locationId: null,
          pendingCreate: false,
          mapWaypointRole: null,
        }],
      locations: [],
      markers: [
        {
          lat: 0,
          lng: 0
        },
        {
          lat: 0,
          lng: 0
        },
      ],
    }
  },
  props: {
    cached_markers: {
      type: Array,
      required: false,
      default: () => []
    },
    selected_points_cloned: {
      type: Array,
      required: false,
      default: () => []
    },
    reset_all: {
      type: Boolean,
      default: false
    },
    userAt: {
      type: Object,
      default: null,
    },
  },
  emits: ['push-markers', 'reverse-points', 'set-locations-names', 'set-waypoint-labels'],
  methods: {
    createEmptyPlanPoint() {
      return {
        label: '',
        point: { address: null, position: null },
        points: null,
        showList: false,
        showCombinedList: false,
        origin_locations_open: false,
        postcode: null,
        name: null,
        locationId: null,
        pendingCreate: false,
        mapWaypointRole: null,
      };
    },
    inferMapWaypointRole(sidebarIndex) {
      if (sidebarIndex === 0) {
        return 'start';
      }
      if (sidebarIndex === this.points.length - 1) {
        return 'destination';
      }
      return 'via';
    },
    hasAtLeastOneFilledPlace() {
      return this.points.some(isFilledPlanPoint);
    },
    suggestDefaultLocationName(role) {
      if (role === 'start') {
        return 'Origin';
      }
      if (role === 'destination' || role === 'via') {
        return `${Math.max(this.points.length - 1, 1)} drop`;
      }
      return '';
    },
    trimTrailingEmptyPoints() {
      const points = [...this.points];
      while (points.length > 1 && !isFilledPlanPoint(points[points.length - 1])) {
        points.pop();
      }
      return points;
    },
    filledPointsForRoute() {
      return this.points.filter(isFilledPlanPoint);
    },
    compactMarkersFromPointsWithSidebar() {
      const markers = [];
      this.points.forEach((p, sidebarIndex) => {
        if (!isFilledPlanPoint(p)) {
          return;
        }
        const pos = p.point.position;
        markers.push({
          lat: pos.Latitude,
          lng: pos.Longitude,
          sidebarIndex,
          role:
            p.mapWaypointRole || this.inferMapWaypointRole(sidebarIndex),
        });
      });
      return markers;
    },
    emitNormalizedMarkers() {
      const markers = this.compactMarkersFromPointsWithSidebar();
      this.markers = markers.map((m) => L.latLng(m.lat, m.lng));
      this.$emit('push-markers', markers);
      return markers;
    },
    syncPositionsFromMapWaypoints(waypoints) {
      if (!Array.isArray(waypoints) || !waypoints.length) {
        return;
      }
      const filledSidebarIndices = [];
      this.points.forEach((p, sidebarIndex) => {
        if (isFilledPlanPoint(p)) {
          filledSidebarIndices.push(sidebarIndex);
        }
      });
      waypoints.forEach((wp, seqIdx) => {
        const sidebarIndex = filledSidebarIndices[seqIdx];
        if (sidebarIndex === undefined) {
          return;
        }
        const lat = wp.lat;
        const lng = wp.lng;
        this.points[sidebarIndex].point.position = {
          Latitude: lat,
          Longitude: lng,
        };
        if (wp.role) {
          this.points[sidebarIndex].mapWaypointRole = wp.role;
        }
        while (this.markers.length <= sidebarIndex) {
          this.markers.push(L.latLng(0, 0));
        }
        this.markers[sidebarIndex] = L.latLng(lat, lng);
      });
      this.emitNormalizedMarkers();
    },
    getPendingCreatePoints() {
      return this.points.filter(
        (p) => p.pendingCreate && isFilledPlanPoint(p),
      );
    },
    applyMapWaypoint({
      role,
      lat,
      lng,
      address,
      name,
      locationId,
      pendingCreate,
      postcode,
    }) {
      const displayAddress = buildWaypointDisplayAddress(name, address);
      const position = { Latitude: lat, Longitude: lng };
      const patch = {
        point: { address: displayAddress, position },
        name,
        postcode: postcode ?? null,
        locationId: locationId ?? null,
        pendingCreate: !!pendingCreate,
        showList: false,
        showCombinedList: false,
        origin_locations_open: false,
        mapWaypointRole: role,
      };

      if (role === 'start') {
        Object.assign(this.points[0], patch);
        this.markers[0] = L.latLng(lat, lng);
      } else if (role === 'destination') {
        const destIndex = this.points.length - 1;
        Object.assign(this.points[destIndex], patch);
        while (this.markers.length <= destIndex) {
          this.markers.push(L.latLng(0, 0));
        }
        this.markers[destIndex] = L.latLng(lat, lng);
      } else if (role === 'via') {
        const insertIndex = this.points.length - 1;
        const newPoint = {
          ...this.createEmptyPlanPoint(),
          ...patch,
        };
        this.points.splice(insertIndex, 0, newPoint);
        this.markers.splice(insertIndex, 0, L.latLng(lat, lng));
      }

      this.emitNormalizedMarkers();
      this.emitWaypointLabels();
    },
    emitWaypointLabels() {
      const waypointLabels = this.points.map((point, index) => {
        const pos = point?.point?.position;
        const lat =
          pos?.lat ??
          pos?.Latitude ??
          this.cached_markers?.[index]?.lat ??
          null;
        const lng =
          pos?.lng ??
          pos?.Longitude ??
          this.cached_markers?.[index]?.lng ??
          null;
        return {
          name: point.name || null,
          lat,
          lng,
        };
      });
      this.$emit('set-waypoint-labels', waypointLabels);

      const locationsNames = {
        start: null,
        end: null,
      };
      if (this.points[0]?.name) {
        locationsNames.start = this.points[0].name;
      }
      if (this.points[this.points.length - 1]?.name) {
        locationsNames.end = this.points[this.points.length - 1].name;
      }
      this.locations_names = locationsNames;
      this.$emit('set-locations-names', locationsNames);
    },
    showSavedLocations(index) {
      this.points.forEach((point, i) => {
        if (i !== index) {
          point.showCombinedList = false;
          point.showList = false;
          point.origin_locations_open = false;
        }
      });
      
      // Then show the clicked one
      this.points[index].showCombinedList = true;
      this.points[index].showList = false;
      this.points[index].origin_locations_open = false;
    },
    
    filteredSavedLocations(index) {
      const searchText = this.points[index].point.address;
      if (!searchText || searchText.trim() === '') {
        return this.locations;
      }
      
      return this.locations.filter(location => 
        location.name.toLowerCase().includes(searchText.toLowerCase()) ||
        location.address.toLowerCase().includes(searchText.toLowerCase())
      );
    },
    
    hideAllDropdowns() {
      this.points.forEach(point => {
        point.showCombinedList = false;
        point.showList = false;
        point.origin_locations_open = false;
      });
    },
    
    handleClickOutside(event) {
      const clickedElement = event.target;
      const isInsideComponent = this.$el.contains(clickedElement);
      
      if (!isInsideComponent) {
        this.hideAllDropdowns();
      }
    },
    
    getPauseValue(index) {
      const pauseObj = this.points_pauses.find((p) => p.index === index);
      return pauseObj ? pauseObj.pause : '';
    },
    clearPause(index) {
      // Remove the pause value for the given index
      const pauseInput = this.$refs[`pause_input_${index}`];
      if (pauseInput) {
        pauseInput.value = '';
      }
      const pauseObjIndex = this.points_pauses.findIndex(
          (p) => p.index === index
      );
      if (pauseObjIndex >= 0) {
        this.points_pauses.splice(pauseObjIndex, 1);
        this.$emit('push-pause', this.points_pauses);
      }
    },
    // Update or add a pause value for a given index
    updatePause(index, value) {
      const pause = parseInt(value, 10); // Convert input value to number
      const pauseObjIndex = this.points_pauses.findIndex(
          (p) => p.index === index
      );

      if (pauseObjIndex >= 0) {
        // Update existing pause
        if (pause > 0) {
          this.$set(this.points_pauses, pauseObjIndex, {
            index,
            pause,
          });
        } else {
          // Remove pause if input is empty or invalid
          this.points_pauses.splice(pauseObjIndex, 1);
        }
      } else if (pause > 0) {
        // Add new pause
        this.points_pauses.push({
          index,
          pause,
        });
      }
      if (this.points_pauses.length > 0) {
        this.$emit('push-pause', this.points_pauses);
      } else {
        this.$emit('push-pause', null);
      }
    },
    togglePause(index){
      if(this.input_indexes_allow_pause.includes(index)) {
        this.input_indexes_allow_pause = this.input_indexes_allow_pause.filter(i => i !== index);
      } else {
        this.input_indexes_allow_pause.push(index);
      }
    },
    addPoint() {
      if (this.points.length > 50) {
        return;
      }
      this.points.push(this.createEmptyPlanPoint());
    },
    async backToOrigin() {
      if (!this.points[0].point.address) {
        return;
      }
      const firstPoint = this.points[0];
      const firstMarker = this.markers[0];

      if (!this.points[this.points.length - 1].point.address) {
        // delete last point
        this.points.pop();
        this.markers.pop();
      }
        this.points.push(firstPoint);
        this.markers.push(firstMarker);


      this.emitNormalizedMarkers();
      this.emitWaypointLabels();
    },
    async reverseTwoPoints(index) {
      // Rebuild points around the given index
      this.points = await rebuildPointsByIndex(this.points, index);

      // If index is the first or last point, drop its pause
      if (index === 1 || index === this.points.length - 1) {
        this.dropPauseByIndex(index);
        this.dropPauseByIndex(index-1);
      } else {
        // Determine the range of indexes to reverse (index-1 and index)
        let startIndex = index - 1;
        let endIndex = index;

        // Reverse pauses and allowed pause indexes in the range [startIndex, endIndex]
        this.reversPauseByIndex(startIndex, endIndex);
        this.$emit('push-pause', this.points_pauses);
      }

      // Emit the reverse-points event
      this.$emit('reverse-points', index);
      this.emitWaypointLabels();
    },

    reversPauseByIndex(startIndex, endIndex) {
      // Reverse indexes in points_pauses within the range [startIndex, endIndex]
      this.points_pauses = this.points_pauses.map((pauseObj) => {
        if (pauseObj.index >= startIndex && pauseObj.index <= endIndex) {
          return {
            ...pauseObj,
            index: startIndex + endIndex - pauseObj.index
          };
        }
        return pauseObj;
      });

      // Reverse indexes in input_indexes_allow_pause within the range [startIndex, endIndex]
      this.input_indexes_allow_pause = this.input_indexes_allow_pause.map((index) => {
        if (index >= startIndex && index <= endIndex) {
          return startIndex + endIndex - index;
        }
        return index;
      });
    },
    dropPauseByIndex(index) {
      this.points_pauses = this.points_pauses.filter(p => p.index !== index);
      this.input_indexes_allow_pause = this.input_indexes_allow_pause.filter(i => i !== index);
      this.$emit('push-pause', this.points_pauses);
    },
    deletePoint(index) {
      if(this.points.length <= 1) {
        return
      }
      this.markers.splice(index, 1);
      this.points.splice(index, 1);
      this.emitNormalizedMarkers();
      this.emitWaypointLabels();
    },
    async selectLocation(val, index) {
      this.locations_names = {
        start: null,
        end: null
      }
      this.points[index].origin_locations_open = false;
      this.points[index].showCombinedList = false;
      this.points[index].showList = false;
      this.points[index].point.address = val.name ? val.name + ', ' + val.address : val.address;
      this.points[index].point.position = {
        Latitude: val.geo.latitude,
        Longitude: val.geo.longitude
      }
      if (val.name) {
        this.points[index].name = val.name;
      }
      this.points[index].postcode = val.postcode;
      this.points[index].mapWaypointRole = this.inferMapWaypointRole(index);
      if (this.markers[index]) {
        this.markers[index] = await L.latLng(val.geo.latitude, val.geo.longitude);
      } else {
        this.markers.push(L.latLng(val.geo.latitude, val.geo.longitude));
      }
      this.emitNormalizedMarkers();

      if (this.points[0].name) {
        this.locations_names.start = this.points[0].name;
      }

      this.emitWaypointLabels();
    },
    saveLocation(val, name, index = 0) {
      if (!val.point.position) {
        infoMessage(
            'Oops. Something went wrong...','error'
        );
      }
      if (val.point && val.point.address) {
        this.selected_location = val.point;
        this.selected_location_name = name;
        this.selected_location.position = {
          Latitude: this.cached_markers[index].lat,
          Longitude: this.cached_markers[index].lng
        }
        this.$refs.create_location_modal.show = true;
      }
    },
    closeCreateLocationModal(val) {
      if (val) {
        infoMessage(
            `Location created`,
            this.getTopBanner ? 'success open_top_banner' : 'success'
        );
      } else {
        infoMessage(
            'Oops. Something went wrong...',
            this.getTopBanner ? 'error open_top_banner' :'error'
        );
      }
    },
    async updateDropOption(option, index) {
      this.points[index].point.address = option.address;
      this.points[index].point.position = option.position;
      this.points[index].name = null;
      this.points[index].showList = false;
      this.points[index].showCombinedList = false;
      this.points[index].origin_locations_open = false;
      this.points[index].postcode = option.address.split(', ')[0];
      this.points[index].mapWaypointRole = this.inferMapWaypointRole(index);
      if (this.markers[index]) {
        this.markers[index] = await L.latLng(option.position.Latitude, option.position.Longitude);
      } else {
        this.markers.push(L.latLng(option.position.Latitude, option.position.Longitude));
      }

      this.emitNormalizedMarkers();
      this.emitWaypointLabels();
    },
    async searchAllPoints(index) {
      let dropOff = await this.searchPoints(this.points[index]?.point?.address, index) || null;
      this.points[index].points = dropOff;
      
      this.points[index].showCombinedList = true;
      this.points[index].showList = false;
      this.points[index].origin_locations_open = false;
    },
    async searchPoints(searchReq, index) {
      const user = await JSON.parse(localStorage.getItem('user'));
      try {
        return await searchAddressesDebounced(
          this.$http,
          searchReq,
          user?.id,
          `plan-location-${index}`,
          this.userAt,
        );
      } catch (err) {
        const errors = err.response?.data?.message;
        if (typeof errors === 'string') {
          infoMessage(errors || 'Oops. Something went wrong...', 'error');
        } else {
          this.errorsHandler?.(errors);
        }
        return [];
      }
    },
    async getLocations()  {
      try {
        const requestData = {
          skip: 0,
          take: 999,
          sort: 'name',
          column: 'name',
          search: '',
          ascending: false,
        }
        const response = await this.$http
            .getAuth(`${this.$http.apiUrl()}/locations?skip=${requestData.skip}&take=${requestData.take}&sort-by=${requestData.sort}&column=${requestData.column}&search=${requestData.search}&sort=${requestData.ascending}`);

        this.locations = response?.data?.locations?.data || [];

        if (this.$route.name === 'HereRePlan') {
          this.points = this.selected_points_cloned;
          this.emitWaypointLabels();
        }
      } catch (e) {
        console.log(e);
      }
    },

    async parsePauses() {
      if (this.$route.name !== 'HereRePlan') {
        return;
      }
      if (this.selected_points_cloned && this.selected_points_cloned?.length) {
        this.selected_points_cloned.forEach((item, index) => {
          if (item.postActions && item.postActions.length && item.postActions[0].action === 'wait') {
            this.input_indexes_allow_pause.push(index)
            this.points_pauses.push({
              index: index,
              pause: item.postActions[0].duration / 60
            })
            this.input_indexes_allow_pause.push(index);
          }
        })
        this.$emit('push-pause', this.points_pauses);
      }
    },

    async getPoints() {
      this.setAddVehicles(false);
      this.setAddTrailers(false);
      if (this.points[1].point.position == null || this.points[0].point.position == null) {
        return infoMessage('Please add route drops...', 'error')
      }

      let request_data = {
        pois: this.points,
        dates: this.pickerDates,
        v_size: this.calcFinalDimentions(),
        tolls: this.preferences.tolls,
        tunnels: this.preferences.tunnels,
        motorways: this.preferences.motorways
      }

      this.waypoints = [];
      this.setLoading(true)

      let result = await this.$http.postAuth(`${this.$http.apiUrl()}/subscriptions/directions`, request_data);
      let status = 0;
      let errMsg = null;
      if (result?.data[0]) {
        result.data.forEach(item => {
          if (item[0] && item[0].status && item[0].status != 0) {
            status = item[0].status;
            errMsg = item[0].detail[0].reason;
          }
          if (item.status && item.status != 0) {
            status = item.status;
            errMsg = item.detail[0].reason;
          }
        })
      }

      if (status > 0) {
        this.setLoading(false)
        return infoMessage(
            errMsg || 'Sorry, no compliant route found',
            'error'
        )
      }

      await this.clearMultiWaypoints()
      await this.clearMultiWaypointsText()
      for await (const item of result?.data) {
        await this.parseCoordinates(item)
      }

      this.timeDurationDistanceParse();
      this.direction_data = result.data;

      let thObj = this;
      this.points.forEach((item, index) => {
        let firstPart = item.point.address.split(', ');
        let secondPart = null;
        let secondRegion = null;
        let secondPostcode = null;
        let secondFullAddress = null;
        if (index + 1 < thObj.points.length) {
          secondPart = thObj.points[index + 1]?.point?.address?.split(', ') || null;
          secondRegion = secondPart[2] || null;
          secondPostcode = secondPart[0] || null;
          secondFullAddress = thObj.points[index + 1]?.point?.address;
        }
        thObj.partDistance.push({
          from:{
            region: firstPart[2] || null,
            postcode: firstPart[0] || null,
            address: item.point.address,
            admin_district: firstPart[2] || null
          },
          to:{
            region: secondRegion,
            postcode: secondPostcode,
            address: secondFullAddress,
            admin_district: secondRegion || null
          },
        })
      })

      this.setLoading(false)
      this.allowDrug = false;
    },
  },
  watch: {
    "selected_points_cloned": {
      handler: function (val) {
        if (val && val.length) {
          this.parsePauses();
        }
      },
      deep: true
    },
    "cached_markers": {
      handler: function (val) {
        this.markers = val;
      },
      deep: true
    },
    "reset_all": {
      async handler(val) {
        if (val) {
          this.points = [
            this.createEmptyPlanPoint(),
            this.createEmptyPlanPoint(),
          ];
          this.markers = [];
          this.locations_names = {
            start: null,
            end: null
          }
          this.emitNormalizedMarkers();
          this.$emit('set-locations-names', this.locations_names)
          this.$emit('set-waypoint-labels', [])
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getLocations();
    
    document.addEventListener('click', this.handleClickOutside);
  },
  
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style lang="scss" scoped>
.plus-icon {
  border: 2px solid #1FBC2F;
  border-radius: 50%;
  padding: 2px;
}
.add-point-text {
  padding-top: 2px;
  color: #1FBC2F;
}
.vue2leaflet-map {
  height: 877px;
}
.revers_drops {
  position: absolute;
  z-index: 1;
  right: -10px;
  width: 25px;
  bottom: 90%;
  &.has_pause {
    bottom: 140%;
  }
}
.location-name {
  font-weight: bold;
 // font-size: 14px;
  color: #292929;
}
.add_items {
  position: absolute;
  top: 180px;
  left: 400px;
  min-height: 150px;
  z-index: 400;
  background-color: #fff;
  border-radius: 5px;
  &.r-side{
    left: calc(35% + 400px);
  }
}
.not-allow-banner {
  padding-top: 150px;
  margin-bottom: 200px;
}
.page {
  position: relative;
  .white-green {
    cursor: pointer;
  }
  .drivers {
    .white-green {
      padding: 12px;
    }
  }
  .inner {
    &.way {
      max-height: 650px;
      max-width: 350px;
      min-width: 320px;
      overflow-y: hidden;
    }
  }
  .vue-range-slider.slider-component {
    .slider {
      .slider-dot {
        background-color: #1fbc2f !important;
      }
    }
  }
  .vehicles {
    .actions {
      .white-green {
        text-align: center;
        margin: auto;
      }
    }
  }
  .vue-range-slider {
    width: 100%!important;
  }
  .alt_header {
    position: absolute;
    height: 50px;
    z-index: 401;
  }
  .pause-input-wrapper {
    display: flex;

    align-items: baseline;
    justify-content: center;
    max-width: 80%;
    gap: 10px;
  }
  .pause-input {
    border: 1px solid #D0D5DA;
    box-sizing: border-box;
    border-radius: 50px;
    width: 30%;
    max-height: 30px;
    margin-top: 10px;
    input {

      line-height: 5px;
      padding-top: 0px;
    }
    .input_actions {
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 1;
      cursor: pointer;
    }
  }
  .outer {
    position: relative;

    border: 1px solid #D0D5DA;
    box-sizing: border-box;
    border-radius: 50px;
    width: 95%;
    .input_actions {
      position: absolute;
      right: 0;
      top: 8px;
      min-width: 52px;
      padding-right: 10px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      //  gap: 8px;
    }
  }
  .plan_options {
    min-width: 355px;
    position: absolute;
    left: 15px;
    z-index: 401;
    border-radius: 6px;
    background-color: #ffffff;
    .actions {
      .white-green {
        padding-top: 0;
        padding-bottom: 0;
        min-height: 44px;
      }
    }
    &>.inner {
      padding: 15px;
      max-height: 600px;
      overflow: hidden;
    }
  }
  .position_plan_options {
    top: 90px;
  }
  .position_plan_options_plus {
    top: 90px;
  }
}
.btn_danger {
  padding: 7px 10px;
}
.input-group {
  input {
    max-width: 258px;
    background: white;
    padding-left: 5px;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
    border: none;
    background: transparent;
    outline: transparent;
  }
}
.input_actions {
  gap: 0; 
}
.outer .input_actions {
  gap: 0;
}
.plan_item {
  .expand {
    padding-right: 10px;
    .active {
      svg {
        transform: rotate(180deg);
      }
    }
  }
  .mb30 {
    .flex {
      width: 100%;
      .mr-2 {
        margin: 0;
        width: 100%;
      }
      .vue-daterange-picker {
        width: 100%;
      }
    }
  }
}
.actions {
  &.save {
    padding-top: 15px;
    button {
      min-width: 80px;
    }
  }
}
.preferences {
  input[type="radio"] {
    max-width: 20px;
    &:checked {
      &:checked {
        background: #FFA800 !important;
        border: #FFA800 !important;
      }
      &:before, &:after {
        background: #FFA800 !important;
        border: #FFA800 !important;
      }
    }
  }
}
.vue-daterange-picker ::v-deep .reportrange-text{
  border: 1px solid #D0D5DA;
  box-sizing: border-box;
  border-radius: 18px !important;
  width: 100%;
}
.data {
  padding-bottom: 20px;
  .icon {
    width: 20px;
  }
}
.icon {
  &.rotated {
    width: 44px;
    height: 44px;
    background: #fff;
    border-radius: 8px;
    left: 15px;
    position: absolute;
    top: 150px;
    z-index: 999;
  }
}
.add_name {
  position: absolute;
  max-width: 400px;
  left: 0;
  right: 0;
  top: 300px;
  margin: auto;
  z-index: 401;
  background: #fff;
}
.closeZone {
  transform: rotate(180deg);
  float: left;
}
.openZone {
  background: #fff;
  padding: 5px 5px;
  border-radius: 4px;
  width: 34px;
  border: 2px solid rgba(0,0,0,.2);
  background-clip: padding-box;
}
.custom-control {
  .controls {
    width: 230px;
    height: 150px;
    padding-left: 15px;
    background-color: #fff;
    img {
      max-width: 20px;
    }
  }
}
.no_visibility {
  opacity: 0;
}
.input_actions .flag, .input_actions .delete, .input_actions .down {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: -6px;
}
.dropdown_block {
  width: 95%;
  padding: 0 10px;
  z-index: 405;
  background: #ffffff;
  border: 1px solid #D0D5DA;
  box-sizing: border-box;
  border-radius: 5px;
  position: absolute;
  top: 37px;
  left: 0;
}

.combined-dropdown {
  width: 95%;
  padding: 0;
  z-index: 405;
  background: #ffffff;
  border: 1px solid #D0D5DA;
  box-sizing: border-box;
  border-radius: 5px;
  position: absolute;
  top: 37px;
  left: 0;
  max-height: 300px;
  overflow-y: auto;
}

.saved-locations-section {
  padding: 0px 10px 0px 10px;
}

.address-search-section {
  padding: 0px 10px 10px 10px;
}

.section-divider {
  height: 1px;
  background-color: #E0E0E0;
  margin: 5px 0;
}

.saved-location-item {
  // background-color: #f8fff8;
  border-radius: 4px;
  margin-bottom: 2px;
  padding: 8px 10px !important;
  
  &:hover {
    background-color: #f5f5f5;
  }
}

.search-result-item {
  padding: 8px 10px !important;
  
  &:hover {
    background-color: #f5f5f5;
  }
}

.bookmark-icon {
  flex-shrink: 0;
  fill: #1FBC2F;
}
.title {
  font-size: 14px;
}
.locations{
  &.absolute {
    background-color: #fff;
    width: 100%;
    z-index: 100;
  }
}
.down {
  .rotate {
    transform: rotate(180deg);
  }
}
</style>